<div>

  <syn-file
    class="drop_area"
    size="medium"
    accept=".sdp"
    droparea="true"
    multiple="false"
    helpText="Set .{{ projectFileExtension }} file(s) to migrate."
    (synInputEvent)="onInputFileChanged($event)">
  </syn-file>

  <div class="list_uploadedFiles" *ngIf="files != 0">
    <h3>
      Selected files
    </h3>
    <ul>
      <li *ngFor="let file of files">{{ file.name }}</li>
    </ul>
  </div>

  <div class="progressBar" *ngIf="showProgressBar">
    File: {{currentFileCount}}/{{fileAmount}} {{currentFileName}}
    <syn-progress-bar indeterminate="true"></syn-progress-bar>
  </div>

  <div class="error_info" *ngIf="invalidData || erroneousResponse">
    <syn-icon class="error_icon" name="error" />
    <div class="error_text">{{ errorMessage }}</div>
    <ul class="list_errorFiles">
      <li *ngFor="let item of errorFiles">{{ item }}</li>
    </ul>
  </div>

  <div class="success_info" *ngIf="show_success_msg">
    <syn-icon class="success_icon" name="check_circle" />
    <div class="success_text">{{ success_msg }}</div>

  </div>

  <div class="avb_text">
    <syn-checkbox
      [(checked)]="isAvbAccepted">
      I have read and accept the <a target="_blank" rel="noopener" href="https://www.sick.com/tools/tac/en/General-Terms-Conditions-Supply-Software-Products-AVB-Software-SICK.pdf">General Terms and Conditions for the Supply of Software Products</a>.
    </syn-checkbox>
  </div>

  <div>
    <syn-button
      class="button"
      variant="filled"
      [loading]="isUploading"
      [disabled]="files.length <= 0 || invalidData || !isAvbAccepted || isUploading"
      (click)="uploadButtonClick()"
      (keyup)="onKeyUp($event)">
      <syn-icon slot="prefix" name="upload"></syn-icon>
      {{ files.length > 1 ? 'Convert files' : 'Convert file' }}
    </syn-button>
  </div>

</div>
